<template>
  <ul class="common-problem">
    <li>
      <h3>
        <i></i>{{$t('other.w67')}}
      </h3>
      <p>{{$t('other.w68')}}</p>
    </li>
    <li>
      <h3>
        <i class="t2"></i>{{$t('other.w69')}}
      </h3>
      <p>{{$t('other.w70')}}</p>
    </li>
    <li>
      <h3>
        <i class="t3"></i>{{$t('other.w71')}}
      </h3>
      <p>{{$t('other.w72')}}</p>
    </li>
    <li>
      <h3>
        <i class="t4"></i>{{$t('other.w73')}}
      </h3>
      <p>{{$t('other.w74')}}</p>
    </li>
     <li>
      <h3>
        <i class="t5"></i>{{$t('other.w75')}}
      </h3>
      <p>{{$t('other.w76')}}</p>
    </li>
  </ul>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.common-problem {
  height: 742px;
  background: #fff;
  padding: 30px 44px 0 30px;
  li {
    h3 {
      font-size: 18px;
      color: #333333;
      font-weight: 500;
      margin-bottom: 15px;
      i {
        background: url("../../../assets/borrow/01@2x.png") no-repeat;
        background-size: cover;
        display: inline-block;
        width: 40px;
        height: 40px;
        margin-right: 5px;
        vertical-align: bottom;
      }
      .t2 {
        background: url("../../../assets/borrow/02@2x.png") no-repeat;
        background-size: cover;
      }
      .t3 {
        background: url("../../../assets/borrow/03@2x.png") no-repeat;
        background-size: cover;
      }
      .t4 {
        background: url("../../../assets/borrow/04@2x.png") no-repeat;
        background-size: cover;
      }
      .t5 {
        background: url("../../../assets/borrow/05@2x.png") no-repeat;
        background-size: cover;
      }
    }
    p {
    //   min-height: 67px;
      color: #7b7b7c;
      font-size: 14px;
      margin-bottom: 40px;
    }
  }
}
</style>

